import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { tableOpts, globalTableStyle } from 'Configs/table'
import ContentWrapper from 'Comps/container/ContentWrapper'
import Alert from 'Comps/elements/Alert'
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import WarningIcon from '@material-ui/icons/Warning';
import DeleteIcon from '@material-ui/icons/Delete';
import TableNoData from 'Comps/elements/TableNoData'
import LoadingContent from 'Elements/LoadingContent';
import Table from 'Elements/Table'
import { deleteSalesOrder, setEditSalesOrder, resetStatusSalesOrder, salesOrderGetById } from 'Reduxes/consignment/salesorder/salesOrderActions'
import { loadProduct } from 'Reduxes/inventory/product/productActions'
import { scrollToTop, money, moneyToInt, globalMessage, globalDialog } from '@/Helper'
import Label from 'Elements/Label'
import CustomToolbar from "../../../comps/elements/CustomToolbar";
import PrintProvider, { Print, NoPrint } from "react-easy-print";
import KopSurat from 'Elements/KopSurat'
import SelectFilter from 'Elements/SelectFilter'

import {
  FormGroup,
  FormLabel,
  FormControl,
  ListItemText,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  Select,
  InputLabel,
  MenuItem
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import Permission from '../../../comps/permission/Permission';

const useStyles = makeStyles((theme) => ({
  spacer: {
    height: "25px"
  }
}));


export default function TableData(props) {
  const localClass = useStyles();
  const { showDetail, showForm } = props;
  const { data, loading, error, success } = useSelector(state => state.salesOrderReducer);
  const parsedData = data.map(singleData => {
    return {
      ...singleData,
      name: singleData.contact.name
    }
  })
  // console.log('ini data table data', data)
  const classes = globalTableStyle();
  const dispatch = useDispatch();

  const handleDelete = async id => {
    let allowDelete = true;
    id.forEach(i => {
      const isFound = data.find(d => d.id === i)
      if (isFound && isFound.status !== 'draft') {
        allowDelete = false;
      }
    });

    if (!allowDelete) {
      globalMessage('You only allowed to delete data with status \'Draft\'', 'warning')
      return;
    }

    globalDialog(async () => {
      await dispatch(deleteSalesOrder(id))
      scrollToTop()
    })
  }


  const [date, setdate] = useState({
    dateFilterChecked: false
  })

  const [subTotal, setSubTotal] = useState({
    subTotalFilterChecked: false
  })

  const [disc, setDisc] = useState({
    discFilterChecked: false
  })

  const [total, setTotal] = useState({
    totalFilterChecked: false
  })


  //OPTIONS UNTUK SELECT CUSTOM FILTER 
  const uniqueContact = [...new Set(parsedData.map(item => item.name))];
  const contactOptions = uniqueContact.map(item => {
    return {
      value: item,
      label: item
    }
  })

  const table = tableOpts({
    handleDelete,
    data: parsedData,
    colIdPosition: 0,
    filename: "Sales_Order_Data",
    table: {
      columns: [
        {
          name: 'id',
          options: {
            display: false,
            viewColumns: false,
            filter: false
          }
        },
        // FIELD NOMOR
        {
          name: 'no',
          label: 'No.',
          options: {
            customBodyRender: (value, tableMeta) => {
              return tableMeta.rowIndex + 1
            },
            filter: false
          }
        },
        // {
        //   name: 'id', label: 'id',
        //   options: { display: false, filter: false, print: false }
        // },
        // {
        //   name: 'is_warning', label: 'is_warning',
        //   options: { display: false, filter: false, print: false }
        // },

        // FIELD TANGGAL
        {
          name: "date",
          label: 'Date',
          options: {
            filter: true,
            filterType: 'custom',
            customFilterListOptions: {
              render: v => {
                if (v[0] && v[1] && date.dateFilterChecked) {
                  return [`Min Date: ${v[0]}`, `Max Date: ${v[1]}`];
                } else if (v[0] && v[1] && !date.dateFilterChecked) {
                  return `Min Date: ${v[0]}, Max Date: ${v[1]}`;
                } else if (v[0]) {
                  return `Min Date: ${v[0]}`;
                } else if (v[1]) {
                  return `Max Date: ${v[1]}`;
                }
                return [];
              },
              update: (filterList, filterPos, index) => {
                // console.log('customFilterListOnDelete: ', filterList, filterPos, index);

                if (filterPos === 0) {
                  filterList[index].splice(filterPos, 1, '');
                } else if (filterPos === 1) {
                  filterList[index].splice(filterPos, 1);
                } else if (filterPos === -1) {
                  filterList[index] = [];
                }

                return filterList;
              },
            },

            filterOptions: {
              names: [],
              logic(date, filters) {


                if (filters[0] && filters[1]) {
                  return Date.parse(date) < Date.parse(filters[0]) || Date.parse(date) > Date.parse(filters[1]);
                } else if (Date.parse(filters[0])) {
                  return Date.parse(date) < Date.parse(filters[0]);
                } else if (Date.parse(filters[1])) {
                  return Date.parse(date) > Date.parse(filters[1]);
                }
                return false;
              },
              display: (filterList, onChange, index, column) => (
                <div>
                  <FormLabel className={localClass.title}>Date</FormLabel>
                  <div className={localClass.spacer}></div>
                  <FormGroup row>
                    <TextField
                      variant="outlined"
                      label='min'
                      value={filterList[index][0] || ''}
                      onChange={event => {
                        filterList[index][0] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%', marginRight: '5%' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      type="date"
                    />
                    <TextField
                      variant="outlined"
                      label='max'
                      value={filterList[index][1] || ''}
                      onChange={event => {
                        filterList[index][1] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      type="date"
                    />

                  </FormGroup>
                </div>
              ),
            },
          }
        },
        // FIELD ID
        {
          name: 'code',
          label: 'Code',
          options: {
            filter: false
          }
        },
        // FIELD KONTAK
        {
          name: "name",
          label: 'Contact',
          options: {
            filter: true,
            filterType: 'custom',
            customFilterListOptions: {
              render: v => {
                if (v[4].length === 1 && v[4][0]?.value === "") {  // index harus di sesuaikan dengan posisi column
                  return [];
                } else if (v[4].length) {
                  const val = v[4].map(x => x.value);
                  return [`Contact : ${val.join(', ')}`]
                }
                return [];

              },
              update: (filterList, filterPos, index) => { // untuk update chip filter diatas table
                if (filterPos === 0) {
                  filterList[index] = [];
                }
                return filterList;

              }
            },
            filterOptions: {
              logic(value, filters) {
                const dataFilter = filters[4]?.map(item => item.value)
                return !dataFilter || !dataFilter.length ? false : !dataFilter.includes(value); // jika tidak ada filter akan ditampilkan semua data di table

              },

              display: (filterList, onChange, index, column) => (
                <>
                  <SelectFilter
                    label="contact"
                    name="contact"
                    handleChange={select => {
                      filterList[index] = select || [];
                      onChange(filterList, index, column);
                    }}
                    options={contactOptions}
                    defaultValue={filterList[index][index]}
                  />
                </>
              )

            }

          }
        },
        // FIELD SUB TOTAL
        {
          name: 'sub_total',
          label: 'Sub Total',
          options: {
            customBodyRender: (value) => {
              return `IDR ${money(value)}`
            },
            filter: true,
            filterType: 'custom',
            customFilterListOptions: {
              render: v => {
                if (v[0] && v[1] && subTotal.subTotalFilterChecked) {
                  return [`Min Price: ${v[0]}`, `Max Price: ${v[1]}`];
                } else if (v[0] && v[1] && !subTotal.subTotalFilterChecked) {
                  return `Min Price: ${v[0]}, Max Price: ${v[1]}`;
                } else if (v[0]) {
                  return `Min Price: ${v[0]}`;
                } else if (v[1]) {
                  return `Max Price: ${v[1]}`;
                }
                return [];
              },
              update: (filterList, filterPos, index) => {
                // console.log('customFilterListOnDelete: ', filterList, filterPos, index);

                if (filterPos === 0) {
                  filterList[index].splice(filterPos, 1, '');
                } else if (filterPos === 1) {
                  filterList[index].splice(filterPos, 1);
                } else if (filterPos === -1) {
                  filterList[index] = [];
                }

                return filterList;
              },
            },
            filterOptions: {
              names: [],
              logic(price, filters) {

                if (filters[0] && filters[1]) {
                  return moneyToInt(price) < parseInt(filters[0]) || moneyToInt(price) > parseInt(filters[1]);
                } else if (filters[0]) {
                  return moneyToInt(price) < filters[0];
                } else if (filters[1]) {
                  return moneyToInt(price) > filters[1];
                }

                return false;
              },
              display: (filterList, onChange, index, column) => (
                <div>
                  <FormLabel>Sub Total</FormLabel>
                  <div className={localClass.spacer}></div>
                  <FormGroup row>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='min'
                      value={filterList[index][0] || ''}
                      onChange={event => {
                        filterList[index][0] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%', marginRight: '5%' }}
                      type='number'
                    />
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='max'
                      value={filterList[index][1] || ''}
                      onChange={event => {
                        filterList[index][1] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                      type='number'

                    />
                  </FormGroup>
                </div>
              )

            }
          }
        },
        // FIELD DISCOUNT
        {
          name: 'total_discount',
          label: 'Discount',
          options: {
            customBodyRender: (value) => {
              return `IDR ${money(value)}`
            },
            filter: true,
            filterType: 'custom',
            customFilterListOptions: {
              render: v => {
                if (v[0] && v[1] && disc.discFilterChecked) {
                  return [`Min Discount: ${v[0]}`, `Max Discount: ${v[1]}`];
                } else if (v[0] && v[1] && !disc.discFilterChecked) {
                  return `Min Discount: ${v[0]}, Max Discount: ${v[1]}`;
                } else if (v[0]) {
                  return `Min Discount: ${v[0]}`;
                } else if (v[1]) {
                  return `Max Discount: ${v[1]}`;
                }
                return [];
              },
              update: (filterList, filterPos, index) => {
                // console.log('customFilterListOnDelete: ', filterList, filterPos, index);

                if (filterPos === 0) {
                  filterList[index].splice(filterPos, 1, '');
                } else if (filterPos === 1) {
                  filterList[index].splice(filterPos, 1);
                } else if (filterPos === -1) {
                  filterList[index] = [];
                }

                return filterList;
              },
            },
            filterOptions: {
              names: [],
              logic(price, filters) {

                if (filters[0] && filters[1]) {
                  return moneyToInt(price) < parseInt(filters[0]) || moneyToInt(price) > parseInt(filters[1]);
                } else if (filters[0]) {
                  return moneyToInt(price) < filters[0];
                } else if (filters[1]) {
                  return moneyToInt(price) > filters[1];
                }

                return false;
              },
              display: (filterList, onChange, index, column) => (
                <div>
                  <FormLabel>Discount</FormLabel>
                  <div className={localClass.spacer}></div>
                  <FormGroup row>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='min'
                      value={filterList[index][0] || ''}
                      onChange={event => {
                        filterList[index][0] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%', marginRight: '5%' }}
                      type='number'
                    />
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='max'
                      value={filterList[index][1] || ''}
                      onChange={event => {
                        filterList[index][1] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                      type='number'
                    />
                  </FormGroup>
                </div>
              )

            }
          }

        },
        // FIELD TOTAL
        {
          name: 'total',
          label: 'Total',
          options: {
            customBodyRender: (value) => {
              return `IDR ${money(value)}`
            },
            filter: true,
            filterType: 'custom',
            customFilterListOptions: {
              render: v => {
                if (v[0] && v[1] && total.totalFilterChecked) {
                  return [`Min Price: ${v[0]}`, `Max Price: ${v[1]}`];
                } else if (v[0] && v[1] && !total.totalFilterChecked) {
                  return `Min Price: ${v[0]}, Max Price: ${v[1]}`;
                } else if (v[0]) {
                  return `Min Price: ${v[0]}`;
                } else if (v[1]) {
                  return `Max Price: ${v[1]}`;
                }
                return [];
              },
              update: (filterList, filterPos, index) => {
                // console.log('customFilterListOnDelete: ', filterList, filterPos, index);

                if (filterPos === 0) {
                  filterList[index].splice(filterPos, 1, '');
                } else if (filterPos === 1) {
                  filterList[index].splice(filterPos, 1);
                } else if (filterPos === -1) {
                  filterList[index] = [];
                }

                return filterList;
              },
            },
            filterOptions: {
              names: [],
              logic(price, filters) {

                if (filters[0] && filters[1]) {
                  return moneyToInt(price) < parseInt(filters[0]) || moneyToInt(price) > parseInt(filters[1]);
                } else if (filters[0]) {
                  return moneyToInt(price) < filters[0];
                } else if (filters[1]) {
                  return moneyToInt(price) > filters[1];
                }

                return false;
              },
              display: (filterList, onChange, index, column) => (
                <div>
                  <FormLabel>Total</FormLabel>
                  <div className={localClass.spacer}></div>
                  <FormGroup row>
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='min'
                      value={filterList[index][0] || ''}
                      onChange={event => {
                        filterList[index][0] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%', marginRight: '5%' }}
                      type='number'
                    />
                    <TextField
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label='max'
                      value={filterList[index][1] || ''}
                      onChange={event => {
                        filterList[index][1] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                      type='number'

                    />
                  </FormGroup>
                </div>
              )

            }
          }
        },
        {
          name: "status",
          label: 'Status',
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              let type = '';
              if (value === 'draft') {
                type = 'grey';
              } else if (value === 'confirmed') {
                type = 'primary'
              } else if (value === 'waiting') {
                type = 'warning'
              } else if (value === 'delivered') {
                type = 'delivered'

              } else if (value === 'invoiced') {
                type = 'invoiced'
              } else {
                type = 'success';
              }

              return <Label text={value} type={type} />
            },
            filter: true,
            filterType: 'checkbox',
            // filterOptions: {
            //     names: ['Draft', 'Confirmed' ,'Waiting','Delivered','Invoiced','Done'],
            //     logic(val, filterVal) {
            //     const show =
            //             (filterVal.indexOf('Draft') >= 0  && val ==='draft')||
            //             (filterVal.indexOf('Confirmed') >= 0  && val ==='confirmed') ||
            //             (filterVal.indexOf('Waiting') >= 0  && val ==='waiting') ||
            //             (filterVal.indexOf('Delivered') >= 0  && val ==='delivered') ||
            //             (filterVal.indexOf('Invoiced') >= 0  && val ==='invoiced') ||
            //             (filterVal.indexOf('Done') >= 0  && val ==='done') 


            //     return !show;
            //     },
            // },
          }
        },
        {
          name: "id",
          label: 'Action',
          options: {
            setCellHeaderProps: () => ({
              style: {
                whiteSpace: "nowrap",
                position: "sticky",
                right: 0,
                zIndex: 51
              }
            }),
            setCellProps: () => ({

              style: {
                whiteSpace: "nowrap",
                position: "sticky",
                right: "0",
                background: "white",
                zIndex: 51
              }
            }),
            filter: false,
            print: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              // console.log(tableMeta);
              const attrShow = {
                className: 'row-action',
                onClick: () => {
                  showDetail(value)
                }
              }
              const attrEdit = {
                className: 'row-action',
                onClick: () => {
                  dispatch(setEditSalesOrder(value))
                  dispatch(loadProduct());
                  showForm('Edit')
                  scrollToTop()
                }
              }
              const attrDelete = {
                className: 'row-action',
                onClick: () => handleDelete([value])
              }

              return (
                <>
                  <VisibilityIcon {...attrShow} />
                  { tableMeta.rowData[8] === 'open' && <WarningIcon className="row-action red" />}
                  {
                    tableMeta.rowData[8] === 'draft' &&
                    <Permission
                      component={<EditIcon {...attrEdit} />}
                      subMenu="sales_order"
                      type="update"
                    />
                  }
                  {
                    tableMeta.rowData[8] !== 'done' &&
                    <Permission
                      component={<DeleteIcon {...attrDelete} />}
                      subMenu="sales_order"
                      type="delete"
                    />
                  }
                </>
              );
            }
          }
        },
      ],
    },
  })

  return (
    <PrintProvider>
      <Print single name="print-salesorder-table-1" >
        <KopSurat />
        <div className="spacer-60"></div>
        <ContentWrapper
          title="Sales Order"
          subtitle="showing table of all sales order"
          buttons={[
            {
              label: 'Add Sales Order',
              style: 'OrangeMd',
              icon: 'plus-circle',
              onClick: () => showForm('New'),
              subMenu: 'sales_order',
              type: 'create',
            }
          ]}
        >
          <>
            {
              success &&
              <Alert hide={() => dispatch(resetStatusSalesOrder())} option={{ type: 'success', message: success }} />
            }
            {
              error && <Alert hide={() => dispatch(resetStatusSalesOrder())} option={{ type: 'error', message: error }} />
            }
            {
              loading ? <LoadingContent />
                : (
                  data.length ?
                    <Table {...table} className={classes.table} />
                    : <TableNoData />
                )
            }
          </>
        </ContentWrapper>
      </Print>
    </PrintProvider>
  )
}